import React from 'react';
import IndustryTemplate, { IndustryConfig } from './IndustryTemplate';

const config: IndustryConfig = {
  slug: 'real-estate',
  label: 'Real Estate',
  heroTitle: 'Monetize Your',
  heroDim: 'Property Data Assets',
  heroSubtitle:
    'Real estate firms hold rich datasets — property records, transaction histories, market analyses, and lease data. Efficient helps you license this data to AI companies building the next generation of property intelligence tools.',
  heroImage: '/real-estate-hero.webp',
  heroImageAlt: 'Real estate office',
  processSteps: [
    {
      num: '01',
      icon: '/step_door.svg',
      title: 'Data Assessment',
      desc: 'We evaluate your firm\'s data holdings — listings, transactions, valuations — and identify what commands the highest prices in the AI market.',
    },
    {
      num: '02',
      icon: '/step_onboard.svg',
      title: 'Qualification',
      desc: 'We match your datasets to active AI buyer requirements and provide a transparent valuation and revenue estimate.',
    },
    {
      num: '03',
      icon: '/step_extract.svg',
      title: 'Preparation',
      desc: 'We structure, anonymize where required, and format your data for delivery — with no disruption to your operations.',
    },
    {
      num: '04',
      icon: '/step_paid.svg',
      title: 'Revenue Recognition',
      desc: 'You receive a share of every transaction. Your firm\'s proprietary data becomes a recurring income asset.',
    },
  ],
  valueHeading: 'What real estate data can be monetized',
  valueProps: [
    {
      title: 'Transaction & Sales Records',
      desc: 'Historical transactions capture real market intelligence — what properties actually traded for and why, refined through years of deals in your market.',
    },
    {
      title: 'Listing & Property Attributes',
      desc: 'Detailed listing data reflects granular knowledge of your market — the attributes that matter to buyers and renters that only experienced agents truly understand.',
    },
    {
      title: 'Lease & Rental Data',
      desc: 'Lease terms and rental histories show how markets actually behave over time — the ground-level insight that only comes from managing real properties.',
    },
  ],
  aiAccelHeading: 'Close faster and price smarter with AI.',
  aiAccelPoints: [
    {
      title: 'Automated Valuation & Market Analysis',
      desc: 'AI-assisted CMAs and valuation models help your team price listings more accurately and respond to client questions faster.',
    },
    {
      title: 'Document Processing',
      desc: 'Automate contract review, disclosure preparation, and due diligence summaries — reducing the manual work on every transaction.',
    },
    {
      title: 'Lead Scoring & Client Matching',
      desc: 'AI models trained on transaction data can score inbound leads and match buyers to listings more effectively than manual review.',
    },
  ],
  ctaHeading: 'Put your property data to work',
  ctaBody:
    'Join our network of real estate partners and create recurring revenue from the market data you already capture.',
};

export default function RealEstate() {
  return <IndustryTemplate config={config} />;
}
